import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const PRODUCT_API_URL = `${API_HOST}/api/product`;
const PRODUCT_CATEGORY_API_URL = `${PRODUCT_API_URL}/category`;

function* createProduct() {
  yield takeEvery(actions.CREATE_PRODUCT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], PRODUCT_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_PRODUCT_ENDED });
    }
  });
}

function* createProductCategory() {
  yield takeEvery(actions.CREATE_PRODUCT_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], PRODUCT_CATEGORY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_PRODUCT_CATEGORY_ENDED });
    }
  });
}

function* searchProducts() {
  yield takeEvery(actions.SEARCH_PRODUCTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${PRODUCT_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_PRODUCTS_ENDED });
    }
  });
}

function* searchProductCategories() {
  yield takeEvery(actions.SEARCH_PRODUCT_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${PRODUCT_CATEGORY_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_PRODUCT_CATEGORIES_ENDED });
    }
  });
}

function* findProductCategory() {
  yield takeEvery(actions.FIND_PRODUCT_CATEGORY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${PRODUCT_CATEGORY_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_PRODUCT_CATEGORY_ENDED });
    }
  });
}

function* updateProduct() {
  yield takeEvery(actions.UPDATE_PRODUCT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], PRODUCT_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_PRODUCT_ENDED });
    }
  });
}

function* updateProductCategory() {
  yield takeEvery(actions.UPDATE_PRODUCT_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], PRODUCT_CATEGORY_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_PRODUCT_CATEGORY_ENDED });
    }
  });
}

function* deleteProducts() {
  yield takeEvery(actions.DELETE_PRODUCTS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], PRODUCT_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_PRODUCTS_ENDED });
    }
  });
}

function* deleteProductCategories() {
  yield takeEvery(actions.DELETE_PRODUCT_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], PRODUCT_CATEGORY_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_PRODUCT_CATEGORIES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createProduct),
    fork(createProductCategory),
    fork(searchProducts),
    fork(searchProductCategories),
    fork(findProductCategory),
    fork(updateProduct),
    fork(updateProductCategory),
    fork(deleteProducts),
    fork(deleteProductCategories),
  ]);
}
